export const VERIFICATION_MODE = {
  VERIFICATION_AUTO: 1,
  VERIFICATION_MANUAL: 2,
};
